export default __webpack_public_path__ + "static/media/vc.18402a16.svg";